export const Events = {
    generateAnalysis: 'generate-analysis-clicked',
    goToDownloadReport: "goto-download-report",
    downloadPDFClicked: "download-pdf-clicked"
}